import "./RecoveryCodeSkeleton.css";

const RecoveryCodeSkeleton = () => {
  return (
    <div className="grid grid-cols-2 gap-6 p-2 w-full">
      {Array.from({ length: 10 }).map((_, index) => (
        <div key={index} className="w-1/2 flex items-left text-nowrap">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="77"
            height="8"
            viewBox="0 0 77 8"
            fill="none"
            className="animate-shimmer"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.5 4C0.5 1.79086 2.29086 0 4.5 0L72.5 0C74.7091 0 76.5 1.79086 76.5 4C76.5 6.20914 74.7091 8 72.5 8L4.5 8C2.29086 8 0.5 6.20914 0.5 4Z"
              fill="url(#paint0_linear_16051_52519)"
            />

            <defs>
              <linearGradient
                id="paint0_linear_16051_52519"
                x1="76.5"
                y1="8"
                x2="74.8342"
                y2="-7.82466"
                gradientUnits="userSpaceOnUse"
              >
                <stop
                  stopColor="#282828"
                  style={{
                    stopColor: "#282828",
                    stopOpacity: 1,
                  }}
                />

                <stop
                  offset="1"
                  stopColor="#363636"
                  style={{
                    stopColor: "#363636",
                    stopOpacity: 1,
                  }}
                />
              </linearGradient>
            </defs>
          </svg>
        </div>
      ))}
    </div>
  );
};

export default RecoveryCodeSkeleton;
